export const TAGS = {
  ai: '3476093',
}
